import { api } from '@api'
import { Scope } from '@utils'
import { FetchParams, PaginatedResponse } from './types'
import { usePaginate } from './usePaginate'

export enum EventType {
  PRIVATE = 'private',
  COMMON = 'common',
  ALL = 'all',
}

export type CalendarEvent = {
  id: string
  title: string
  description: string
  startDateTime: string
  endDateTime?: string | null
  allDay?: boolean | null
  rrule?: string | null
  location: {
    place: string
    city?: string
    country?: string
    state?: string
    region?: string
  }
  type: EventType
  scope: string
  participantAccountIds: string[]
  hasReminder: boolean
  descriptionAsReminder: boolean
  isDone?: boolean
  createdAt: string
  updatedAt: string
}

const fetchCalendarEvents = async ({ pageParam = '0', search, scope, date }: FetchParams): Promise<PaginatedResponse<CalendarEvent>> => {
  let url = `/calendar-events?page=${pageParam}`
  if (search) url += `&search=${search}`
  if (scope) url += `&scope=${scope}`
  if (date) url += `&date=${date}`
  
  const { data } = await api.get<PaginatedResponse<CalendarEvent>>(url)
  return data
}

export const usePaginateCalendarEvents = ({ search, scope, date }: { search?: string, scope?: Scope, date?: string } = {}) => {
  return usePaginate<CalendarEvent>('calendar-events', fetchCalendarEvents, { search, scope, date })
}

